export default ()=>
<>CollectionSimpleView</>